var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-user-avatar",style:({ width: _vm.size + 'px', height: _vm.size + 'px' })},[_c('span',{staticClass:"avatar-name"},[_vm._v(_vm._s(_vm.user_display_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }